import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faFile } from "@fortawesome/free-solid-svg-icons";

import { updateLanguageInHeaders } from "../../network/api";
import {
  storeApp,
  storeuserRole,
} from "../../Store/TemplateStore/template.action";

import DupontButton from "../DupontButton";
import { API_URLS } from "../../network/appUrls";
import { saveUser } from "../../network/cipAPI";

import "./index.scss";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import DupontIconButton from "../DupontIconButton";

const basePath = API_URLS.basePath;

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    userName,
    userRole,
    userEmail,
    firstName,
    lastName,
    companyName,
    userCountry,
  } = useSelector((state) => state);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    updateLanguageInHeaders(lng);
  };

  const payload = {
    name: firstName,
    email_id: userEmail,
    last_name: lastName,
    company: companyName,
    country: userCountry,
  };
  const saveUserDetails = async (payload) => {
    try {
      let response = await saveUser(payload);
      const { user_role } = response;
      dispatch(storeuserRole(`${user_role}`));
    } catch (error) {
      console.error("Error saving user information:", error);
    }
  };
  const onHomeClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    const path = `${basePath}plant`;
    navigate(path);
  };

  const onMenuClicked = () => {
    dispatch(storeApp(null));
    saveUserDetails(payload);
    setMenuOpen((prev) => !prev);
  };

  const handleManageAccess = () => {
    dispatch(storeApp(null));
    setMenuOpen(false);
    navigate(`${basePath}admin-portal`);
  };

  const handleUserManual = () => {
    setMenuOpen(false);
    const userManualUrl = process.env.REACT_APP_USER_MANUAL_URL;
    if (userManualUrl) {
      window.open(userManualUrl, "_blank");
    }
  };

  return (
    <div className="header_container">
      <div className="home flex-between-center ">
        <div>
          <DupontIconButton
            onClick={onHomeClicked}
            tooltip={t("adminPage.home")}
          >
            <FontAwesomeIcon icon={faHome} />
          </DupontIconButton>

          <DupontIconButton
            onClick={handleUserManual}
            tooltip={t("adminPage.userManual")}
          >
            <FontAwesomeIcon icon={faFile} />
          </DupontIconButton>

          <div
            style={{ position: "relative", display: "inline-block" }}
            ref={menuRef}
          >
            <DupontIconButton>
              <FontAwesomeIcon icon={faCircleUser} onClick={onMenuClicked} />
            </DupontIconButton>
            {menuOpen && (
              <div
                style={{
                  position: "absolute",

                  top: "100%",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  zIndex: 1000,
                  width: "240px",
                }}
              >
                {/* <div
                  style={{ padding: "8px 16px", cursor: "pointer" }}
                  onClick={handleUserManual}
                >
                  {t("adminPage.userManual")}
                </div> */}
                {userRole === "admin" && (
                  <div
                    style={{ padding: "8px 16px", cursor: "pointer" }}
                    onClick={handleManageAccess}
                  >
                    {t("adminPage.manageAcess")}
                  </div>
                )}
              </div>
            )}
          </div>

          <span className="welcome-container ">{`${t(
            "welcomeString.welcome",
          )}, ${userName}`}</span>
        </div>
        <div className="padding-80 ">
          <DupontButton
            type="tertiary"
            customClass="button-terninarty-custom-width"
            onClick={() => changeLanguage("en")}
            disabled={props.activeStep && props.activeStep > 0}
          >
            en
          </DupontButton>{" "}
          <DupontButton
            type="tertiary"
            customClass="button-terninarty-custom-width"
            onClick={() => changeLanguage("zh")}
            disabled={props.activeStep && props.activeStep > 0}
          >
            中文
          </DupontButton>
        </div>
      </div>

      <div className="header-divider" />
      <div className="container-dupont-icon">
        <div
          className="dupont-icon "
          onClick={() => {
            onHomeClicked();
          }}
        >
          <div>
            <img src={require("../../assets/DuPont_Logo.png")} height="30px" />
            <div className="water-solution">
              {t("headerString.waterSolution")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
